<template>
<div class="content" id="BusinessIndex">
	<router-view />
</div>
</template>
<script>
export default {
    name: 'BusinessIndex',
    //组件创建
    created() {
    },
    data() {
        return{
        }
    },
    methods:{
    }
}
</script>
<style lang="less" scoped>
</style>